import { Component, useEffect, useState } from "react";
import Lenis from "lenis";
import { translations } from "@/i18n";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Usp } from "@/components/landing/Usp";
import { Services } from "@/components/landing/Services";
import { Marquee } from "@/components/landing/Marquee";
import { Team } from "@/components/landing/Team";
import { References } from "@/components/landing/References";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error) {
    console.error("Landing crashed:", error);
  }
  render() {
    if (this.state.failed) {
      return (
        <div data-testid="landing-error-fallback" className="min-h-screen flex items-center justify-center bg-paper px-4">
          <div className="text-center max-w-md">
            <p className="font-jakarta text-xl font-semibold tracking-tight text-slate-900">
              Etwas ist hängengeblieben — bitte einmal neu laden.
            </p>
            <p className="mt-2 text-sm text-slate-500">Something got stuck — please reload once.</p>
            <button
              data-testid="landing-error-reload"
              onClick={() => window.location.reload()}
              className="mt-6 inline-flex items-center justify-center rounded-full bg-[#003940] px-6 py-3 text-sm font-semibold text-white hover:bg-[#002A2F] transition-colors"
            >
              Neu laden / Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function Landing() {
  const [lang, setLang] = useState("de");
  const t = translations[lang];

  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, anchors: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <div data-testid="landing-page" className="bg-paper text-[#0A272C] min-h-screen font-jakarta antialiased overflow-x-hidden">
      <ErrorBoundary>
        <Nav t={t} lang={lang} setLang={setLang} />
        <main>
          <Hero t={t} />
          <Usp t={t} />
          <Services t={t} />
          <Marquee t={t} />
          <Team t={t} lang={lang} />
          <References t={t} />
          <Contact t={t} />
        </main>
        <Footer t={t} />
      </ErrorBoundary>
    </div>
  );
}
